'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CloseIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CloseIcon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2144_8511)">
          <path
            d="M0.5 15.4994L15.5 0.49939"
            stroke={sx?.color || '#3D517B'}
            strokeOpacity="0.56"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.5 15.4994L0.5 0.49939"
            stroke={sx?.color || '#3D517B'}
            strokeOpacity="0.56"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2144_8511">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

CloseIcon.propTypes = {
  sx: PropTypes.object
}
